import React, { useState } from 'react';
import '../../App.css';
import api, { setAccessToken } from '../../utils/api.js';
import { handleApiError } from '../../utils/errorHandler.js';
import { useTenant } from '../../contexts/TenantContext.js';

const LoginPage = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { tenantSlug, isLoading: tenantLoading } = useTenant();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // FastAPI standard OAuth2PasswordRequestForm expects form-data
        const formData = new FormData();
        formData.append('username', email);
        formData.append('password', password);

        // テナントslug（必須）
        formData.append('tenant_slug', tenantSlug);

        try {
            const response = await api.fetch('/auth/login', {
                method: 'POST',
                // Don't set Content-Type header when using FormData; the browser will set it automatically with the boundary
                body: formData,
            });

            if (!response) return; // Redirected (though unlikely on login)

            if (response.ok) {
                const data = await response.json();
                // Access Tokenをメモリに保存（localStorageではなく）
                setAccessToken(data.access_token);
                // Refresh TokenはHttpOnly Cookieで自動的に設定されている

                // フルリロードで全コンポーネントをクリーンな状態で初期化
                // （リロード後にAuthContextのfetchCurrentUserでテナント検証が実行される）
                window.location.href = '/';
            } else {
                const errorMessage = await handleApiError(response, 'ログインに失敗しました。');
                setError(errorMessage);
            }
        } catch (err) {
            setError('通信エラーが発生しました。バックエンドが起動しているか確認してください。');
        } finally {
            setLoading(false);
        }
    };

    // テナント情報のロード中はスケルトン表示
    if (tenantLoading) {
        return (
            <div className="auth-container">
                <div className="auth-card">
                    <div className="skeleton-container skeleton-fade-in" role="status" aria-label="読み込み中" style={{ padding: '20px 0' }}>
                        <div className="skeleton-line" style={{ height: '24px', width: '40%', margin: '0 auto 16px' }} />
                        <div className="skeleton-line" style={{ height: '40px', width: '100%', marginBottom: '12px' }} />
                        <div className="skeleton-line" style={{ height: '40px', width: '100%', marginBottom: '12px' }} />
                        <div className="skeleton-line" style={{ height: '42px', width: '100%', borderRadius: '8px' }} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <h1 className="auth-title">ログイン</h1>
                    <p className="auth-subtitle">ユーザー情報を入力してください</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-form-group">
                        <label className="auth-label" htmlFor="email">メールアドレス</label>
                        <input
                            id="email"
                            type="email"
                            className="auth-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            required
                            disabled={loading}
                        />
                    </div>
                    <div className="auth-form-group">
                        <label className="auth-label" htmlFor="password">パスワード</label>
                        <div className="password-toggle-container">
                            <input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                className="auth-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                                disabled={loading}
                                style={{ paddingRight: '50px' }}
                            />
                            <button
                                type="button"
                                className="password-toggle-button"
                                onClick={() => setShowPassword(!showPassword)}
                                disabled={loading}
                            >
                                {showPassword ? '隠す' : '表示'}
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="auth-error">
                            {typeof error === 'object' ? JSON.stringify(error) : error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="auth-button"
                        disabled={loading}
                    >
                        {loading ? 'サインイン中...' : 'サインイン'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
